type RequestErrorShape = {
  name?: unknown;
  message?: unknown;
  response?: { status?: unknown };
  config?: { method?: unknown; url?: unknown };
};

// Which request failed: its method and address, without the query string
// (a query string can carry values; the method and the path do not).
const requestLabel = (config: RequestErrorShape['config']): string => {
  if (typeof config?.url !== 'string' || !config.url) return '';
  const method = typeof config.method === 'string' ? `${config.method.toUpperCase()} ` : '';
  return `${method}${config.url.split(/[?#]/)[0]}`;
};

// What went wrong, in a form that is safe to log: the error's name and message
// and, for a failed request, its status and which request it was. The error
// object itself is not safe - a failed request's error carries the body that
// was sent, which for the account calls is a name, an email address or a phone
// number.
export const summarizeError = (error: unknown): string => {
  const { name, message, response, config } = (error ?? {}) as RequestErrorShape;
  const label = typeof name === 'string' && name ? name : 'Error';
  const detail = typeof message === 'string' && message ? `: ${message}` : '';
  const requestFacts = [
    typeof response?.status === 'number' ? `HTTP ${response.status}` : '',
    requestLabel(config),
  ].filter(Boolean);
  return `${label}${detail}${requestFacts.length ? ` (${requestFacts.join(', ')})` : ''}`;
};
